var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.08 70.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.5,32.47c1.42.7,2.82,1.96,4.26,2,9.72.27,19.44.26,29.17.4,1.31.02,2.61.39,3.91.6-.04.56-.07,1.12-.11,1.68h-35.64c.23,3.75.39,6.45.57,9.41,3.03,0,6.09.05,9.14-.05.48-.02,1.26-.59,1.38-1.04,1.6-6.45,7.24-5.04,11.47-5.47,3.33-.34,7.52-.33,8.51,4.69.07.37,1.75.65,2.67.61,11.78-.58,23.56-1.24,35.35-1.86,8.94-.47,17.89-.92,26.92-.61-25.12,4-50.44,6.25-75.89,9.4-.12,1.48-.23,2.81-.36,4.39-.13-1.45-.24-2.68-.39-4.39-10.58,1.14-22.16,2.36-32.63,3.49-.05-.18.13-.2.08-.39,2.84-.79,6.57-1.84,9.41-2.63,1.22.27,2.47.85,3.67.75,4.69-.4,9.36-1.01,14.17-1.55-1.81-2.86-3.52-5.28-7.44-4.4-3.06.69-6.72-.58-8.81,2.96,2.78-4.42,1.02-9.11.83-13.71-.06-1.46-.1-2.91-.15-4.37l-.09.08ZM142.79,50.77v.19c1.86-.14,3.74-.14,5.56-.46,2.37-.42,3.68-1.89,3.64-4.43-.04-2.41-.51-4.7-3.4-4.76-3.66-.07-7.38.02-10.98.61-2.75.46-3.28,2.92-3.04,5.47.24,2.56,1.98,3.26,4.16,3.36,1.35.06,2.71.01,4.07.01ZM151.63,48.78c.2.48.4.97.6,1.45,16.05-1.85,32.11-3.7,48.16-5.54-14.74-.04-29.41.61-44.06,1.51-1.61.1-3.14,1.68-4.7,2.57ZM143.56,36.51c0-.25.01-.5.02-.75h-21.47c0,.25.01.5.02.75h21.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.03,52.67c2.67.81,6.22,1.85,8.89,2.66-.04.17-.05.21-.08.39-8.03-.91-16.96-2.14-25.01-2.69-2.24-.15-5.18-2.66-7.1.85-.09-.25-.12-.59-.29-.74-.56-.49-1.19-.91-2.5-1.88-.12,2.27-.19,3.7-.26,5.12-.04,0-.09.01-.13.02-.06-1.32-.12-2.64-.21-4.53-24.4-2.71-48.86-5.43-73.32-8.15.03-.35.07-.7.1-1.06,4.24,0,8.48-.14,12.71.03,14.57.57,29.13,1.25,43.69,1.88.25.01.53-.11.74-.03,4.16,1.78,7.61,1.22,9.97-3,0,0-.05-.07-.05-.07.21.67.81,1.54.58,1.97-2.38,4.46-1.38,6.86,3.41,7.14,3.68.22,7.39-.01,11.08-.05l-.07-.08c.43.53.81,1.47,1.3,1.53,4.54.61,9.08,1.13,13.64,1.51.94.08,1.95-.54,2.92-.84ZM66.04,50.23c.2-.48.41-.96.61-1.43-1.42-.89-2.79-2.47-4.26-2.56-14.77-.91-29.56-1.57-44.34-2.3-.03.26-.05.53-.08.79,16.02,1.83,32.04,3.67,48.07,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.6,32.39c-4.91-3.84-10.29-5.48-16.48-3.64-4.68,1.39-6.27,3.23-6.5,8.2-.2,4.09-.21,8.2-.31,12.29-3.29-2.59-7.21-1.37-10.85-1.65-.8-.06-1.69,1.57-2.63,2.29-.44.34-1.1.39-1.66.58,0,0,.07.08.07.08,3.47-5.27.98-9.4-4.11-9.12-3.64.2-7.31.04-10.96.05,0,0,.05.07.05.07,2.97-.66,5.93-1.33,8.9-2,1.04.37,2.05.95,3.12,1.1,3.16.45,5.71,1.47,5.66,5.37,3.7.37,7.1.71,10.83,1.08v-9.58c-5.67,0-11.37-.09-17.06.1-.88.03-1.72,1.33-2.58,2.04-.61-.7-1.16-1.95-1.84-2.02-3.46-.38-6.95-.44-10.42-.66-1.11-.07-2.22-.25-3.33-.38l-.02-1.25c1.21-.17,2.42-.47,3.63-.48,9.7-.13,19.4-.21,29.1-.3,2.04-.02,3.45-.3,4.71-2.59,1.03-1.86,3.8-3.26,6.05-3.81,2.98-.73,3.62-2.2,3.59-4.92-.07-6.48.05-12.96.2-19.44.03-1.27.54-2.54.83-3.81v27.06c.41,0,.82,0,1.23,0V.62c.28,1.28.77,2.56.79,3.85.12,6.47.23,12.95.09,19.42-.05,2.43.84,3.29,3.04,4.15,2.46.97,4.53,2.91,6.78,4.43,0,0,.09-.09.09-.09ZM96.24,36.49c0-.27.02-.54.03-.81h-18.59c0,.27,0,.54,0,.81h18.56Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75.35,
    cy: 45.14,
    r: 3.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.71,36.51c.04-2.66.36-5.32.98-7.91.06-.25.14-.52.35-.66.26-.17.63-.05.84.18s.3.54.37.85c.77,3.09.89,6.33.4,9.48-.15.97-.37,3.24-1.85,2.23-1.15-.78-1.11-2.96-1.09-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.71,57.99c.04-2.66.36-5.32.98-7.91.06-.25.14-.52.35-.66.26-.17.63-.05.84.18s.3.54.37.85c.77,3.09.89,6.33.4,9.48-.15.97-.37,3.24-1.85,2.23-1.15-.78-1.11-2.96-1.09-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.72,43.52c3.09.04,6.18.36,9.19.98.29.06.6.14.76.35.2.26.06.63-.21.84s-.63.3-.98.37c-3.59.77-7.36.89-11.02.4-1.13-.15-3.76-.37-2.6-1.85.91-1.15,3.45-1.11,4.85-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.08,43.52c3.09.04,6.18.36,9.19.98.29.06.6.14.76.35.2.26.06.63-.21.84s-.63.3-.98.37c-3.59.77-7.36.89-11.02.4-1.13-.15-3.76-.37-2.6-1.85.91-1.15,3.45-1.11,4.85-1.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 143.08,
    cy: 45.14,
    r: 3.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.44,36.51c.04-2.66.36-5.32.98-7.91.06-.25.14-.52.35-.66.26-.17.63-.05.84.18s.3.54.37.85c.77,3.09.89,6.33.4,9.48-.15.97-.37,3.24-1.85,2.23-1.15-.78-1.11-2.96-1.09-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.44,57.99c.04-2.66.36-5.32.98-7.91.06-.25.14-.52.35-.66.26-.17.63-.05.84.18s.3.54.37.85c.77,3.09.89,6.33.4,9.48-.15.97-.37,3.24-1.85,2.23-1.15-.78-1.11-2.96-1.09-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.45,43.52c3.09.04,6.18.36,9.19.98.29.06.6.14.76.35.2.26.06.63-.21.84s-.63.3-.98.37c-3.59.77-7.36.89-11.02.4-1.13-.15-3.76-.37-2.6-1.85.91-1.15,3.45-1.11,4.85-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.81,43.52c3.09.04,6.18.36,9.19.98.29.06.6.14.76.35.2.26.06.63-.21.84s-.63.3-.98.37c-3.59.77-7.36.89-11.02.4-1.13-.15-3.76-.37-2.6-1.85.91-1.15,3.45-1.11,4.85-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.43,34.81c2.35-1.69,5.04-2.91,7.86-3.57.8-.19,1.64-.33,2.43-.12.17.04.34.11.43.25.08.13.09.29.09.45,0,1.84-.01,3.69-.02,5.53-3.14-.08-6.03,1.59-8.72,3.21-1.14.68-2.38,1.51-2.63,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.19,34.06c-3.21-1.53-6.56-3.09-10.12-3.01,0,2.44,0,4.89,0,7.33-.09-.55.67-.79,1.23-.76,3.65.24,6.72,2.71,9.47,5.12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 109.08,
    cy: 46.89,
    rx: 7.41,
    ry: 5.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 108.83,
    cy: 47.93,
    rx: 2.43,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 108.83,
    cy: 65.93,
    rx: 1.31,
    ry: 4.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 72.47,
    cy: 65.08,
    rx: 1.83,
    ry: 4.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 145.5,
    cy: 65.08,
    rx: 1.83,
    ry: 4.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.77,55.47v6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.47,51.39v8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.5,51.39v8.55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane2);
export default __webpack_public_path__ + "static/media/plane2.46760c051692993d0a7494baa0fe1e40.svg";
export { ForwardRef as ReactComponent };